module.exports = __webpack_public_path__ + "img/req_call.165e018d.png";